module.exports = __webpack_public_path__ + "static/media/ic-green-check.7556eaf2.svg";